import { lazy } from 'react';

import { Permission } from '@bookora/shared';
import type { RouteObject } from 'react-router-dom';

import { RequirePermission } from '@/app/require-permission';
import { RouteErrorBoundary } from '@/components/route-error-boundary';

const PhotosPage = lazy(() => import('./photos-page'));

/**
 * Child routes for the photo studio.
 *
 * `/photos/:patientId` is the stable entry point other sections link into —
 * the patients section reaches the gallery through it rather than
 * re-implementing a screen whose whole difficulty is the access-log contract.
 * Keep the path: an appointment note, an audit entry and a patient file all
 * point at it.
 *
 * `<RequirePermission>` is applied here rather than inherited, because the
 * section wrapper in `router.tsx` does not extend to sibling paths.
 */
export const routes: RouteObject[] = [
  {
    path: 'photos/:patientId',
    element: (
      <RequirePermission anyOf={[Permission.PHOTO_VIEW]}>
        <PhotosPage />
      </RequirePermission>
    ),
    // A throw with no boundary of its own bubbles to Root and replaces the
    // whole application rather than the screen that broke.
    errorElement: <RouteErrorBoundary />,
  },
];
